import { Dispensary, MUO } from '@gcv/shared';
import { action, makeAutoObservable } from 'mobx';
import { FilterListChild, FilterListItem } from 'ui';

export class Model {
  constructor() {
    makeAutoObservable(this);
  }

  currentOrg: Dispensary | MUO = {} as Dispensary;
  fetchData = false;
  loadingActivityFilters = false;

  filterArray: {
    [key: string]: {
      accountNumberFilter: FilterListChild[];
      accountsFilter: FilterListItem[];
      salesLocationFilter: FilterListChild[];
    };
  } = {};

  accountsFilter: FilterListItem[] = [];

  accountNumberFilter: FilterListChild[] = [];
  get selectedAccountNumbers() {
    const accountNumbers = this.accountNumberFilter.filter((a) => a.selected);

    // return all account numbers if none are selected
    if (accountNumbers.length) {
      return accountNumbers;
    } else {
      return this.accountNumberFilter;
    }
  }

  salesLocationFilter: FilterListChild[] = [];
  get selectedLocations() {
    const locations = this.salesLocationFilter.filter((l) => l.selected);

    // return all locations if none are selected
    if (locations.length) {
      return locations;
    } else {
      return this.salesLocationFilter;
    }
  }

  previousFilters: FilterListChild[] = [];

  clearFilters = action(() => {
    this.accountNumberFilter = [];
    this.accountsFilter = [];
    this.salesLocationFilter = [];
  });
}

export const model = new Model();
